export default __webpack_public_path__ + "static/media/loginNoBg.b9088b1a.png";